// extracted by mini-css-extract-plugin
export default {"containerAbout":"about_containerAbout__TJW6E","aboutContianer":"about_aboutContianer__s6Oiy","aboutUl":"about_aboutUl__6I0iV"};